import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import cookie from 'react-cookie';
import { isUndefined } from 'lodash';

import { setPage, setPerPage } from '../actions';
import ConsultQueuePager from './consult-queue-pager';
import { DEFAULT_ITEMS_PER_PAGE } from '../constants';

export class ConsultQueuePagerContainer extends Component {
  fetchSelectedPerPageValue = () => {
    const result = cookie.load(`${this.props.pageParamPrefix}_per_page`);
    if (isUndefined(result)) {
      return DEFAULT_ITEMS_PER_PAGE;
    }
    return result;
  }

  render() {
    const { pageParamPrefix, totalEntries, page, perPage, setPage, setPerPage } = this.props;
    return (
      <ConsultQueuePager
        pageParamPrefix={pageParamPrefix}
        totalEntries={totalEntries}
        page={page}
        perPage={perPage}
        selectedPerPage={this.fetchSelectedPerPageValue()}
        setPage={setPage}
        setPerPage={setPerPage}
      />
    );
  }
}

ConsultQueuePagerContainer.propTypes = {
  pageParamPrefix: PropTypes.string.isRequired,
  totalEntries:    PropTypes.number.isRequired,
  page:            PropTypes.number.isRequired,
  perPage:         PropTypes.number.isRequired
};

export const mapDispatchToProps = {
  setPage,
  setPerPage
};

export default connect(
  null,
  mapDispatchToProps
)(ConsultQueuePagerContainer);
